import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NotifMessageService } from 'app/core/services/notifmessage.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { UserService } from 'app/core/services/user.service';
import { AuthenticatedRouteGuard } from 'security/authenticatedRouteGuard.service';
import { KeycloakService } from 'security/keycloak.service';
import { SupplierService } from 'app/core/services/supplier.service';
import { MerchantService } from 'app/core/services/merchant.service';
import { Event } from 'app/core/models/event';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'app/base/base.component';
import { Transaction } from 'app/core/models/transaction';
import { TransactionStateHistory } from 'app/core/models/transactionStateHistory';
import { PaymentTransaction } from 'app/core/models/paymentTransaction';
import { PaymentTransactionStatusHistory } from 'app/core/models/paymentTransactionStatusHistory';
import { TransactionDetailsComponent } from 'app/utilcomponent/modals/transaction-details/transaction-details.component';
import { AbstractModalContentComponent } from './common/abstract.modalContent.component';
import { PosService } from 'app/core/services/pos.service';
import { NGXLogger } from 'ngx-logger';
import { Supplier } from 'app/core/models/supplier';
import { Merchant } from 'app/core/models/merchant';




@Component({
    selector: 'ngbd-modal-content',
    templateUrl: 'templates/confirmDelete.html'
  })
  export class ModalContentDelete {

    @Input()
    name: any;

    @Input()
    headerMessage : any

    @Input()
    bodyMessage : any

    @Input()
    fidelityMessage : any


    constructor(
          public activeModal: NgbActiveModal,
        private notifMessage: NotifMessageService) {

    }
    ok() {
          this.notifMessage.emitResponse(true);
        this.activeModal.close();
  }
    cancel() {
          this.notifMessage.emitResponse(false);
        this.activeModal.close();
  }
}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/saveNeeded.html'
})
export class ModalContentSaveNeeded {

  constructor(
    public activeModal: NgbActiveModal,
    private notifMessage: NotifMessageService) {

  }

  ok() {
    this.notifMessage.emitResponse(true);
    this.activeModal.close();
  }

  cancel() {
    this.notifMessage.emitResponse(false);
    this.activeModal.close();
  }
}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/tokenExpired.html'
})
export class ModalContentTokenExpired {

  constructor(
    public activeModal: NgbActiveModal,
    private notifMessage: NotifMessageService) {

  }

  cancel() {
    this.notifMessage.emitResponse(false);
    this.activeModal.close();
  }
}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/transactionDetails.html'
})
export class ModalContentTransactionDetails extends BaseComponent {

  @Input()
  transaction: Transaction;

  @Input()
  merchantName: string;

  @Input()
  supplierName: string;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    router: Router) {
    super(router);
  }
  ngOnInit() {

  }
  cancel() {
    this.activeModal.close();
  }

  display = false;
  onPress() {
    this.display = true;
  }

  date() {
    let frDateFormat = "dd MMM y, H:mm";
    let usDateFormat = "MMM dd y, hh:mm a";
    if (this.translate.currentLang == "fr_FR")
      return frDateFormat;
    else
      return usDateFormat;
  }

  locale() {
    if (this.translate.currentLang == "fr_FR")
      return "fr_FR";
    else
      return "en_US";
  }

  sortedHistory(): Array<TransactionStateHistory> {
    return this.transaction.transactionStateHistory.sort((a: TransactionStateHistory, b: TransactionStateHistory) => {
      return Date.parse(b.createdDate) - Date.parse(a.createdDate);
    });
  }
  
}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/paymentTransactionDetails.html'
})
export class ModalContentPaymentTransactionDetails extends BaseComponent {

  @Input()
  transaction: PaymentTransaction;

  @Input()
  merchantName: string;

  @Input()
  merchantDeleted: string;

  @Input()
  merchantDeletedDate: string;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    router: Router) {
    super(router);
  }
  ngOnInit() {

  }
  cancel() {
    this.activeModal.close();
  }

  date() {
    let frDateFormat = "dd MMM y, H:mm";
    let usDateFormat = "MMM dd y, hh:mm a";
    if (this.translate.currentLang == "fr_FR")
      return frDateFormat;
    else
      return usDateFormat;
  }

  getLiabilityShift(liabilityShift: Boolean): String{
    if(liabilityShift){
      return "YES";
    }else{
      return "NO";
    }
  }

  locale() {
    if (this.translate.currentLang == "fr_FR")
      return "fr_FR";
    else
      return "en_US";
  }

  sortedHistory(): Array<PaymentTransactionStatusHistory> {
    return this.transaction.paymentTransactionStatusHistory.sort((a: PaymentTransactionStatusHistory, b: PaymentTransactionStatusHistory) => {
      return Date.parse(b.createdDate) - Date.parse(a.createdDate);
    });
  }
}


@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/contentProfile.html'
})
export class ModalContentProfile implements OnInit {

  @Input()
  infosUser: any;
  language: string = "";
  roles = [];
  supplier: Supplier;
  merchant: Merchant;
  isLinkedToSupplier: boolean = false;
  isLinkedToMerchant: boolean = false;
  isLinked: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private configService: ConfigurationService,
    private roleGuard: AuthenticatedRouteGuard,
    private keycloakService: KeycloakService,
    private supplierService: SupplierService,
    private merchantService: MerchantService,) {
  }

  ngOnInit(): void {
    if (this.infosUser.locale) {
      this.language = this.infosUser.locale
    }
    this.getRoles();
    this.getLinkedEntity();
  }

  getLinkedEntity() {
    this.keycloakService.rolesObservable.subscribe(roles => {
      if (roles.length !== 0) {
        if (this.roleGuard.isEnabled('SUPPLIER_READ')) {
          if (this.infosUser.supplierId) {
            
            this.supplierService.getSupplierById(this.infosUser.supplierId).subscribe(supplier => {
              this.supplier = supplier;
              if (supplier) {
                this.isLinkedToSupplier = true;
              } else {
                this.isLinkedToSupplier = false;
              }
              this.checkLinked();
            })
          }
        }
        if (this.roleGuard.isEnabled('MERCHANT_READ')) {
          if (this.infosUser.merchantId) {
            this.merchantService.getMerchantById(this.infosUser.merchantId).subscribe(merchant => {
              this.merchant = merchant;
              if (merchant) {
                this.isLinkedToMerchant = true;
              } else {
                this.isLinkedToMerchant = false;
              }
              this.checkLinked();
            })
          }
        }
      }
    });
  }

  checkLinked() {
    if (this.isLinkedToMerchant || this.isLinkedToSupplier) {
      this.isLinked = true;
    }
  }

  getRoles() {
    this.infosUser.roles.forEach(role => {
      if (this.configService.config.security.keycloak.roles.includes(role)) {
        this.roles.push(role);
      }
    });
    if (this.roles.includes("ADMIN_WORLDLINE")) {
      this.roles = ["ADMIN_WORLDLINE"];
    } else {
      if (this.roles.includes("ADMIN_MERCHANT_PETROL")) {
        let index = this.roles.findIndex(role => role === "VIEWER_MERCHANT_PETROL");
        if (index != -1) {
          this.roles.splice(index, 1);
        }
      }
      if (this.roles.includes("ADMIN_MERCHANT_OPH")) {
        let index = this.roles.findIndex(role => role === "VIEWER_MERCHANT_OPH");
        if (index != -1) {
          this.roles.splice(index, 1);
        }
      }
      if (this.roles.includes("ADMIN_SUPPLIER")) {
        let index = this.roles.findIndex(role => role === "VIEWER_SUPPLIER");
        if (index != -1) {
          this.roles.splice(index, 1);
        }
      }
    }
  }

  quit() {
    this.activeModal.close();
  }
}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/contentUser.html'
})
export class ModalContentUser implements OnInit {

  @Input()
  infosUser: any;
  language: string = "";
  supplier: Supplier;
  merchant: Merchant;
  isLinkedToSupplier: boolean = false;
  isLinkedToMerchant: boolean = false;
  isLinked: boolean = false;


  roles = [];

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private userService: UserService,
    private roleGuard: AuthenticatedRouteGuard,
    private keycloakService: KeycloakService,
    private supplierService: SupplierService,
    private merchantService: MerchantService,
    private configService: ConfigurationService) {
  }

  ngOnInit(): void {
    if (this.infosUser.attributes) {
      this.getLinkedEntity();
      this.language = this.infosUser.attributes.locale[0]
    }
    this.getRoles();
  }

  getLinkedEntity() {
    this.keycloakService.rolesObservable.subscribe(roles => {
      if (roles.length !== 0) {
        if (this.roleGuard.isEnabled('SUPPLIER_READ')) {
          if (this.infosUser.attributes.supplierId && this.infosUser.attributes.supplierId[0]) {
            
            this.supplierService.getSupplierById(this.infosUser.attributes.supplierId[0]).subscribe(supplier => {
              if (supplier.id) {
                this.supplier = supplier;
                this.isLinkedToSupplier = true;
              } else {
                this.isLinkedToSupplier = false;
              }
              this.checkLinked();
            });
          }
        }
        if (this.roleGuard.isEnabled('MERCHANT_READ')) {
          if (this.infosUser.attributes.merchantId && this.infosUser.attributes.merchantId[0]) {
            this.merchantService.getMerchantById(this.infosUser.attributes.merchantId[0]).subscribe(merchant => {
              if (merchant.id) {
                this.merchant = merchant;
                this.isLinkedToMerchant = true;
              } else {
                this.isLinkedToMerchant = false;
              }
              this.checkLinked();
            })
          }
        }
      }
    });
  }

  checkLinked() {
    if (this.isLinkedToMerchant || this.isLinkedToSupplier) {
      this.isLinked = true;
    }
  }

  edit() {
    this.router.navigate(['/user/edit', this.infosUser.id]);
    this.quit();
  }

  getRoles() {
    this.userService.getRoles(this.infosUser).subscribe(roles => {
      roles.forEach(role => {
        if (this.configService.config.security.keycloak.roles.includes(role.name)) {
          this.roles.push(role);
        }
      });
      if (this.roles.some(role => role.name == "ADMIN_WORLDLINE")) {
        this.roles = this.roles.filter(role => role.name == "ADMIN_WORLDLINE");
      } else {
        if (this.roles.some(role => role.name == "ADMIN_MERCHANT_PETROL")) {
          let index = this.roles.findIndex(role => role.name === "VIEWER_MERCHANT_PETROL");
          if (index != -1) {
            this.roles.splice(index, 1);
          }
        }
        if (this.roles.some(role => role.name == "ADMIN_MERCHANT_OPH")) {
          let index = this.roles.findIndex(role => role.name === "VIEWER_MERCHANT_OPH");
          if (index != -1) {
            this.roles.splice(index, 1);
          }
        }
        if (this.roles.some(role => role.name == "ADMIN_SUPPLIER")) {
          let index = this.roles.findIndex(role => role.name === "VIEWER_SUPPLIER");
          if (index != -1) {
            this.roles.splice(index, 1);
          }
        }
      }
    });
  }

  quit() {
    this.activeModal.close();
  }
}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/contactExists.html'
})
export class ModalContactExiste {

  @Input()
  name: any;

  constructor(
    public activeModal: NgbActiveModal,
    private notifMessage: NotifMessageService) {

  }

  cancel() {
    this.activeModal.close();
  }

}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/externalRefExists.html'
})
export class ModalExternalRefExists {

  @Input()
  name: any;

  constructor(
    public activeModal: NgbActiveModal,
    private notifMessage: NotifMessageService) {

  }

  cancel() {
    this.activeModal.close();
  }

}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/errorView.html'
})
export class ModalContentError extends AbstractModalContentComponent {
  @Input()
  error: Event;

  constructor(
    protected supplierService: SupplierService,
    protected merchantService: MerchantService,
    protected translate: TranslateService,
    protected posService: PosService,
      public log: NGXLogger,
      public activeModal: NgbActiveModal,
      public router : Router) {
      super(supplierService,merchantService,posService,log,router);
  }
}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/eventView.html'
})
export class ModalContentEvent extends AbstractModalContentComponent {

  @Input()
  event: Event;

  constructor(
    protected supplierService: SupplierService,
    protected merchantService: MerchantService,
    protected translate: TranslateService,
    protected posService: PosService,
      public log: NGXLogger,
      public activeModal: NgbActiveModal,
      public router : Router) {
      super(supplierService,merchantService,posService,log,router);
  }
}

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: 'templates/alertView.html'
})
export class ModalContentAlert extends AbstractModalContentComponent {

  @Input()
  alert: Event;

  constructor(
    protected supplierService: SupplierService,
    protected merchantService: MerchantService,
    protected translate: TranslateService,
    protected posService: PosService,
      public log: NGXLogger,
      public activeModal: NgbActiveModal,
      public router : Router) {
      super(supplierService,merchantService,posService,log,router);
  }
}

@Component({
  selector: 'app-modal'
})
export class ModalComponent implements OnInit, OnDestroy {

  sub: Subscription;
  modalRef;

  constructor(
    private modalService: NgbModal,
    private config: NgbModalConfig,
    private notifMessage: NotifMessageService) { }

  ngOnInit() {
    this.config.backdrop = 'static';
    this.sub = this.notifMessage.modalSubject$.subscribe(params => {

      switch (params[0]) {
        case "DELETE_MERCHANT":
            this.modalRef = this.modalService.open(ModalContentDelete);
            this.modalRef.componentInstance.name = params[1][0];
            this.modalRef.componentInstance.headerMessage = params[1][1];
            this.modalRef.componentInstance.bodyMessage = params[1][2];
            this.modalRef.componentInstance.fidelityMessage = params[1][3];
            break;

        case "DELETE_SUPPLIER":
            this.modalRef = this.modalService.open(ModalContentDelete);
            this.modalRef.componentInstance.name = params[1][0];
            this.modalRef.componentInstance.headerMessage = params[1][1];
            this.modalRef.componentInstance.bodyMessage = params[1][2];
            this.modalRef.componentInstance.fidelityMessage = params[1][3];
            break;

        case "DELETE_POS":
            this.modalRef = this.modalService.open(ModalContentDelete);
            this.modalRef.componentInstance.name = params[1][0];
            this.modalRef.componentInstance.headerMessage = params[1][1];
            this.modalRef.componentInstance.bodyMessage = params[1][2];
            break;

        case "DELETE_USER":
            this.modalRef = this.modalService.open(ModalContentDelete);
            this.modalRef.componentInstance.name = params[1][0];
            this.modalRef.componentInstance.headerMessage = params[1][1];
            this.modalRef.componentInstance.bodyMessage = params[1][2];
            break;

        case "DELETE_CONTRACT":
          this.modalRef = this.modalService.open(ModalContentDelete);
          this.modalRef.componentInstance.headerMessage = params[1][0];
          this.modalRef.componentInstance.bodyMessage = params[1][1];
          break;

        case "DELETE_FUELLINGPROVIDER":
          this.modalRef = this.modalService.open(ModalContentDelete);
          this.modalRef.componentInstance.headerMessage = params[1][0];
          this.modalRef.componentInstance.bodyMessage = params[1][1];
          break;

        case "DELETE_ACC_ACCOUNT":
          this.modalRef = this.modalService.open(ModalContentDelete);
          this.modalRef.componentInstance.headerMessage = params[1][0];
          this.modalRef.componentInstance.bodyMessage = params[1][1];
          break;

        case "SAVE_NEEDED":
          this.modalRef = this.modalService.open(ModalContentSaveNeeded);
          break;

        case "TOKEN_EXPIRED":
          this.modalRef = this.modalService.open(ModalContentTokenExpired);
          break;

        case "TRANSACTION_DETAILS":
          this.modalRef = this.modalService.open(TransactionDetailsComponent, { centered: true });
          this.modalRef.componentInstance.transaction = params[1][0];
          this.modalRef.componentInstance.merchantName = params[1][1];
          this.modalRef.componentInstance.supplierName = params[1][2];
          break;

        case "PAYMENT_TRANSACTION_DETAILS":
          this.modalRef = this.modalService.open(ModalContentPaymentTransactionDetails, { centered: true });
          this.modalRef.componentInstance.transaction = params[1][0];
          this.modalRef.componentInstance.merchantName = params[1][1];
          this.modalRef.componentInstance.merchantDeleted = params[1][2];
          this.modalRef.componentInstance.merchantDeletedDate = params[1][3];
          break;

        case "PROFILE":
          this.modalRef = this.modalService.open(ModalContentProfile, { centered: true });
          this.modalRef.componentInstance.infosUser = params[1];
          break;

        case "USER":
          this.modalRef = this.modalService.open(ModalContentUser, { centered: true });
          this.modalRef.componentInstance.infosUser = params[1];
          break;

        case "EVENT":
          this.modalRef = this.modalService.open(ModalContentEvent, { centered: true });
          this.modalRef.componentInstance.event = params[1][0];
          this.modalRef.componentInstance.merchantName = params[1][1];
          this.modalRef.componentInstance.supplierName = params[1][2];
          break;

        case "ERROR":
          this.modalRef = this.modalService.open(ModalContentError, { centered: true });
          this.modalRef.componentInstance.error = params[1];
          break;

        case "ALERT":
          this.modalRef = this.modalService.open(ModalContentAlert, { centered: true });
          this.modalRef.componentInstance.alert = params[1];
          break;

        case "CONTACT_EXISTS":
          this.modalRef = this.modalService.open(ModalContactExiste);
          break;

        case "EXTERNAL_REF_EXISTS":
          this.modalRef = this.modalService.open(ModalExternalRefExists);
          break;

        default:
          break;
      }
    });
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}